
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'
import textTraderTitle from '~/components/textTrader/_title.vue'
export default {
  components: {
    'text-title': textTraderTitle
  },
  inject: ['info'],
  data() {
    return {
      LanguageCode: this.$store.state.LanguageCode,
      showArrow: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    bus.$on('TextTraderArrow', (sa) => {
      if (sa && (sa.pos == 'tedian' || sa.pos == 'all') && sa.show) {
        this.showArrow = true
      } else {
        this.showArrow = false
      }
    })
    console.log('亮点')
  },
  methods: {
    HideshowArrow() {
      this.showArrow = false
      bus.$emit('TextTraderArrow', {
        pos: this.postion,
        show: this.showArrow
      })
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
